import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'not-found',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
